import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/Icon';
import { useAuth } from '../App';
import './Dashboard.css';

const metrics = [
  ['Offene Aufgaben', '12', '3 heute fällig', 'gold'],
  ['Aktive Mietverträge', '487', '+2 diese Woche', 'success'],
  ['Skill-Ausführungen', '34', 'Letzten 30 Tage', 'info'],
  ['Offene Posten', '8.420 €', '5 Objekte betroffen', 'warning'],
];

const skills = [
  ['mietvertrag', 'Mietvertragsprüfung', 'Prüfbericht, GVH-Export, Anlagen', 'document'],
  ['sepa', 'SEPA-Mandat', 'Lastschrift erfassen & aktivieren', 'creditCard'],
  ['op-liste', 'OP-Liste', 'Offene Posten als PDF generieren', 'layers'],
];

const activities = [
  ['Mietvertrag Hörmann', 'Prüfbericht erstellt, GVH-Export generiert', '14:32', 'success'],
  ['Kautionskonto', 'IBAN via Getmomo angelegt (Schier. 47)', '14:28', 'gold'],
  ['OP-Liste', 'Objekt 161 exportiert (PDF im DMS)', '11:05', 'info'],
  ['Chat', 'Firmenwissen-Prompt aktualisiert', 'gestern', 'gold'],
];

function getGreeting() {
  const hour = new Date().getHours();
  if (hour < 12) return 'Guten Morgen';
  if (hour < 18) return 'Guten Tag';
  return 'Guten Abend';
}

function formatDate() {
  return new Date().toLocaleDateString('de-DE', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

export default function Dashboard() {
  const { user } = useAuth();
  const firstName = user?.name?.split(' ')[0] || 'Nutzer';

  return (
    <div className="dashboard">
      <div className="dashboard__greeting">
        <h1 className="fleet-headline">{getGreeting()}, {firstName}</h1>
        <p>{formatDate()} - One. immo</p>
      </div>

      <div className="dashboard__metrics">
        {metrics.map(([label, value, sub, accent]) => (
          <div className={`metric-card metric-card--${accent}`} key={label}>
            <div>
              <div className="metric-card__label">{label}</div>
              <div className="metric-card__value">{value}</div>
              <div className="metric-card__sub">{sub}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="dashboard__row">
        <section className="fleet-card">
          <header className="fleet-card__header">
            <h2 className="fleet-card__title">Skills</h2>
            <span className="fleet-card__badge">{skills.length} aktiv</span>
          </header>
          <div className="dashboard__skills">
            {skills.map(([id, name, description, icon]) => (
              <Link to={`/skills/${id}`} className="skill-card" key={id}>
                <span className="skill-card__icon"><Icon name={icon} size={20} /></span>
                <span className="skill-card__title">{name}</span>
                <span className="skill-card__body">{description}</span>
                <span className="skill-card__link">Starten <span className="skill-card__arrow">›</span></span>
              </Link>
            ))}
          </div>
        </section>

        <section className="fleet-card">
          <header className="fleet-card__header">
            <h2 className="fleet-card__title">Letzte Aktivitäten</h2>
            <span className="fleet-card__badge">heute</span>
          </header>
          <div className="activity-feed">
            {activities.map(([title, description, time, status]) => (
              <div className="activity-feed__item" key={`${title}-${time}`}>
                <span className={`activity-feed__dot activity-feed__dot--${status}`} />
                <span className="activity-feed__content">
                  <strong>{title}</strong> - {description}
                </span>
                <span className="activity-feed__time">{time}</span>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
